export default {
    "resultSelector": {
        "selectDocument": "Dokument auswählen",
        "unselectDocument": "Dokumentauswahl aufheben"
    },
    "resultsSelector": {
        "selectDocuments": "{count, selectordinal, =0 {} other {(#)}}",
        "selectDocumentsTitle": "Dokumente auswählen",
        "unselectDocumentsTitle": "Dokumentauswahl aufheben",
    },
    "selection": {
        "selectedDocuments": "{count, plural, =0 {} one {# ausgewähltes Dokument} other {# ausgewählte Dokumente}}"
    }
};
